import React from "react"
import LoginActions from "../../login/LoginActions"
import { Link } from "../../common/components/link";
import { links } from "../../routes";

export const PaymentOk: React.FunctionComponent = () => {
    React.useEffect(() => {
        LoginActions.getAccountInfo();
    })

    return (
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ paddingTop: "5%" }} >
            <div className="card">
                <div className="card-body">
                    <div className="jumbotron bg-white">
                        <h1 className="display-4"><i className="fas fa-check text-success" /> Pagamento completato!</h1>
                        <p className="lead">Il tuo pagamento è stato completato con successo. Ora puoi utilizzare Caldaie Manager senza limitazioni fino alla prossima scadenza.</p>
                        <hr className="my-4" />
                        <p>La fattura del tuo pagamento ti verrà recapitata tramite <strong>fatturazione elettronica al tuo indirizzo pec o codice univoco</strong> che hai fornito in fase di registrazione.</p>
                        <p>Se non hai ancora impostato i tuoi dati di fatturazione <Link to={links.companyEdit}><strong>clicca qui</strong></Link> per impostarli.</p>
                        <p className="lead">
                            <Link
                                className="btn btn-primary btn-lg"
                                to={links.home}
                                role="button"> Torna a Caldaie Manager
                            </Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export const PaymentSmsOk: React.FunctionComponent = () => {
    React.useEffect(() => {
        LoginActions.getAccountInfo();
    })

    return (
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ paddingTop: "5%" }} >
            <div className="card">
                <div className="card-body">
                    <div className="jumbotron bg-white">
                        <h1 className="display-4"><i className="fas fa-check text-success" /> Pagamento completato!</h1>
                        <p className="lead">Il tuo pagamento è stato completato con successo. Ora puoi utilizzare gli SMS acquistati.</p>
                        <hr className="my-4" />
                        <p>La fattura del tuo pagamento ti verrà recapitata tramite <strong>fatturazione elettronica al tuo indirizzo pec o codice univoco</strong> che hai fornito in fase di registrazione.</p>
                        <p>Se non hai ancora impostato i tuoi dati di fatturazione <Link to={links.companyEdit}><strong>clicca qui</strong></Link> per impostarli.</p>
                        <p className="lead">
                            <Link
                                className="btn btn-primary btn-lg"
                                to={links.home}
                                role="button"> Torna a Caldaie Manager
                            </Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}


export const PaymentKo: React.FunctionComponent = () => {
    return (
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ paddingTop: "5%" }} >
            <div className="card">
                <div className="card-body">
                    <div className="jumbotron bg-white">
                        <h1 className="display-4"><i className="far fa-frown text-danger" /> Ops! qualcosa è andato storto...</h1>
                        <p className="lead">Si sono verificati dei problemi in fase di conferma del pagamento.</p>
                        <p className="alert alert-warning">Controlla che i dati inseriti della tua carta di credito siano corretti, che la carta non sia scaduta e che ci sia credito sufficiente per effettuare l'acquisto.</p>
                        <hr className="my-4" />
                        <p>Per qualsiasi chiarimento o verifica rivolgersi all'assitenza di CaldaieManager tramite email <a href="mailto:info@caldaiemanager.it"> <strong>info@caldaiemanager.it</strong></a>. Oppure telefonicamente al <a href="tel:+393392496295">+39 3392496295</a></p>
                        <p className="lead">
                            <Link to={links.paymentPage} className="btn btn-primary btn-lg" role="button">Torna Indietro</Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>);
}